/** What a run covers and whether it rewrites documents already in the vault. */
export type BackfillScope = { isParcelsOnly: boolean; isRestart: boolean };

export const DEFAULT_SCOPE: BackfillScope = {
  isParcelsOnly: false,
  isRestart: false,
};

const OPTIONS: {
  key: keyof BackfillScope;
  label: string;
  title: string;
}[] = [
  {
    key: "isParcelsOnly",
    label: "Colis seulement",
    title:
      "Ne parcourt que les colis : leur destination change après leur création. Retours et commandes restent tels quels.",
  },
  {
    key: "isRestart",
    label: "Refaire",
    title:
      "Repart de zéro sur un shop terminé et réécrit aussi les documents déjà dans le coffre.",
  },
];

export function BackfillScopeFields({
  value,
  onChange,
  hiddenKeys = [],
}: {
  value: BackfillScope;
  onChange: (value: BackfillScope) => void;
  hiddenKeys?: (keyof BackfillScope)[];
}) {
  return (
    <>
      {OPTIONS.filter(({ key }) => !hiddenKeys.includes(key)).map(
        ({ key, label, title }) => (
          <label
            key={key}
            title={title}
            className="flex items-center gap-1.5 text-xs text-muted-foreground"
          >
            <input
              type="checkbox"
              checked={value[key]}
              onChange={(event) =>
                onChange({ ...value, [key]: event.target.checked })
              }
              className="h-4 w-4 accent-violet-600"
            />
            {label}
          </label>
        ),
      )}
    </>
  );
}
